// Lib
import React from 'react';
import useSheet from '../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../mobile/structural/sheet/sheetTypes';
import CommentThreadSheet from './CommentThreadSheet';
import { MNComment } from '../../../../common/comments/commentTypes';
import { ImMNElement } from '../../../../common/elements/elementModelTypes';

// Styles
import './CommentViewMoreButton.scss';

interface CommentViewMoreButtonProps {
    elementId: string;
    element: ImMNElement;
    currentUserId: string;
    commentList: MNComment[];
}

const CommentViewMoreButton: React.FC<CommentViewMoreButtonProps> = (props) => {
    const { elementId, element, currentUserId, commentList } = props;

    const sheetProps = useSheet(SheetId.CommentThread, elementId);
    const { dispatchOpenSheet, dispatchCloseSheet } = sheetProps;

    return (
        <div className="CommentViewMoreButton">
            <div className="view-more-button" onClick={dispatchOpenSheet}>
                View all{commentList.length > 1 ? ` ${commentList.length}` : ''} comments
            </div>
            <CommentThreadSheet
                sheetProps={sheetProps}
                closePopup={dispatchCloseSheet}
                element={element}
                currentUserId={currentUserId}
                commentList={commentList}
            />
        </div>
    );
};

export default CommentViewMoreButton;
